import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import GeneralIngresos from "./IngresosContent/GeneralIngresos";
import Tasas from "./IngresosContent/Tasas";
/* import Costos from "./IngresosContent/Costos"; */
import Reintegros from "./IngresosContent/Reintegros";

class ControlDeIngresos extends Component {
    state = {
        valorOpcion: { value: 'general', label: 'Control de Ingresos' },
    }
    
    Selecciona = (link) => {
        switch (link) {
            case "/ingresos/general":
                return({ value: 'general', label: 'Control de Ingresos' })
            case "/ingresos/tasas":
                return({ value: 'tasas', label: 'Lista de Ingreso por Tasas' })
            /* case "/ingresos/costos":
                return({ value: 'estudiantes', label: 'Verificación de Pago' }) */
            case "/ingresos/reintegros":
                return({ value: 'reintegros', label: 'Reintegros' })
            default:
                return({ value: 'costos', label: 'Costos' })
        }
    }

    valorOpcionesLabel = (link) => {
        switch (link) {
            case "/ingresos/general": return('Control de Ingresos')
            case "/ingresos/tasas": return('Lista de Ingreso por Tasas')
            /* case "/ingresos/costos": return('Costos') */
            case "/ingresos/reintegros": return('Reintegros')
            default: return('General')
        }
    }

    valorSelectOpciones = (valorOpcion) => {
        this.setState({
            valorOpcion
        },() => {
            this.props.history.push(`/ingresos/${this.state.valorOpcion.value}`);
        });
    }

    contenido = () => (
        <Switch>
            <Route path="/ingresos/general" component={ () => <GeneralIngresos/> } />
            <Route path="/ingresos/tasas" component={ () => <Tasas/> } />
            {/* <Route path="/ingresos/costos" component={ () => <Costos/> } /> */}
            <Route path="/ingresos/reintegros" component={ () => <Reintegros/> } />
            <Redirect to = "/ingresos/general" />
        </Switch>
    )
    
    render() {
        const Opciones = [
            { value: 'general', label: 'Control de Ingresos' },
            { value: 'tasas', label: 'Lista de Ingreso por Tasas' },
            /* { value: 'costos', label: 'Costos' }, */
            { value: 'reintegros', label: 'Reintegros' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona una Opción
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorSelectOpciones}
                                    options={Opciones}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`Opciones de ${this.valorOpcionesLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default ControlDeIngresos;


// WEBPACK FOOTER //
// ./src/views/Administracion/ControlDeIngresos.jsx